import getStore from '../store/index.js';
import { v1Endpoints, v2Endpoints } from '../apis/kappa.js';
import { actions as endpointActions } from '../store/state/endpoints.js';

const BATCH_SIZE = 30;

const SOURCES = {
  v1: v1Endpoints.list,
  v2: v2Endpoints.list,
};

export async function loadAllEndpoints(version) {
  const store = getStore();
  store.dispatch(endpointActions.START_LOADING());
  const state = store.getState();

  const source = SOURCES[version];

  let newBatch;
  try {
    newBatch = await source(BATCH_SIZE, state.endpoints.list[version].length);
  } catch (error) {
    store.dispatch(
      endpointActions.LOAD_FAILED({
        version,
        message: error instanceof Error ? error.message : String(error),
      })
    );
    throw error;
  }

  store.dispatch(endpointActions.NEW_BATCH({ version, list: newBatch }));

  if (newBatch.length === BATCH_SIZE) {
    return loadAllEndpoints(version);
  } else {
    store.dispatch(endpointActions.FINISHED_LOADING());
  }
}

export function pushNewEndpoint(version, endpoint) {
  const store = getStore();

  store.dispatch(endpointActions.NEW_BATCH({ version, list: [endpoint] }));
}

export function updateEndpointInList(version, endpoint) {
  function replaceUpdated(currentEndpoint) {
    return currentEndpoint._id === endpoint._id ? endpoint : currentEndpoint;
  }

  const store = getStore();
  const state = store.getState();
  store.dispatch(
    endpointActions.SET_LIST({
      version,
      list: state.endpoints.list[version].map(replaceUpdated),
    })
  );
}

export function removeFromList(version, endpointId) {
  function removeSelected(endpoint) {
    return endpoint._id !== endpointId;
  }

  const store = getStore();
  store.dispatch(endpointActions.START_LOADING());
  const state = store.getState();
  store.dispatch(
    endpointActions.SET_LIST({
      version,
      list: state.endpoints.list[version].filter(removeSelected),
    })
  );
}
